import React from 'react';
import '../home.scss';
import { PublicHomePageViewProps } from './publichomepage.props';

const PublicHomePageView: React.FC<PublicHomePageViewProps> = ({
  lang, setLang, t, races, raceTypes, formValues, loading, error,
  handleInputChange, handleCheckboxChange, handleSubmit,
}) => {
  return (
    <div className="public-home-page">
      <header className="header-section">
        <div className="container">
          <div className="logo">
            <img src="/assets/logo.png" alt="Drim Run Logo" />
          </div>
          <div className="lang-selector">
            <button onClick={() => setLang('en')} className={lang === 'en' ? 'active' : ''}>EN</button>
            <button onClick={() => setLang('mk')} className={lang === 'mk' ? 'active' : ''}>MK</button>
            <button onClick={() => setLang('al')} className={lang === 'al' ? 'active' : ''}>AL</button>
          </div>
        </div>
      </header>

      <section className="hero-section">
        <div className="container">
          <h1>{t?.hero?.title || 'Drim Run'}</h1>
          <p>{t?.hero?.subtitle || 'Join us for an unforgettable race experience'}</p>
        </div>
      </section>

      <section id="register" className="registration-section">
        <div className="container">
          <h2>{t?.raceRegistration || 'Race Registration'}</h2>
          
          {races.length === 0 ? (
            <p>No races available for registration at this time.</p>
          ) : (
            <>
              <form className="registration-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <input 
                    type="text" 
                    name="firstName" 
                    placeholder={t?.reg?.firstName || 'First Name'} 
                    value={formValues.firstName} 
                    onChange={handleInputChange} 
                    required 
                  />
                  <input 
                    type="text" 
                    name="lastName" 
                    placeholder={t?.reg?.lastName || 'Last Name'} 
                    value={formValues.lastName} 
                    onChange={handleInputChange} 
                    required 
                  />
                </div>

                <div className="form-row">
                  <input 
                    type="email" 
                    name="email" 
                    placeholder={t?.reg?.email || 'Email'} 
                    value={formValues.email} 
                    onChange={handleInputChange} 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone" 
                    placeholder={t?.reg?.phone || 'Phone'} 
                    value={formValues.phone} 
                    onChange={handleInputChange} 
                    required 
                  />
                </div>

                <div className="form-row">
                  <input 
                    type="text" 
                    name="city" 
                    placeholder={t?.reg?.city || 'City'} 
                    value={formValues.city} 
                    onChange={handleInputChange} 
                    required 
                  />
                  <input 
                    type="text" 
                    name="country" 
                    placeholder={t?.reg?.country || 'Country'} 
                    value={formValues.country} 
                    onChange={handleInputChange} 
                    required 
                  />
                </div>

                <div className="form-row">
                  <select 
                    name="gender" 
                    value={formValues.gender} 
                    onChange={handleInputChange} 
                    required
                  >
                    <option value="">{t?.reg?.gender || 'Gender'}</option>
                    <option value="Male">{t?.reg?.genderMale || 'Male'}</option>
                    <option value="Female">{t?.reg?.genderFemale || 'Female'}</option>
                    <option value="Other">{t?.reg?.genderOther || 'Other'}</option>
                  </select>
                  <input 
                    type="date" 
                    name="dateOfBirth" 
                    placeholder={t?.reg?.dob || 'Date of Birth'} 
                    value={formValues.dateOfBirth} 
                    onChange={handleInputChange} 
                    required 
                  />
                </div>

                <div className="form-row">
                  <select 
                    name="raceTypeId" 
                    value={formValues.raceTypeId} 
                    onChange={handleInputChange} 
                    required
                  >
                    <option value="">{t?.reg?.raceType || 'Select Race Type'}</option>
                    {raceTypes.map(type => (
                      <option key={type.id} value={type.id}>
                        {type.name} - {type.price} MKD
                      </option>
                    ))}
                  </select>
                  <select 
                    name="participantType" 
                    value={formValues.participantType} 
                    onChange={handleInputChange} 
                    required
                  >
                    <option value="Individual">{t?.reg?.individual || 'Individual'}</option>
                    <option value="Team">{t?.reg?.team || 'Team'}</option>
                  </select>
                </div>

                {formValues.participantType === 'Team' && (
                  <div className="form-row">
                    <input 
                      type="text" 
                      name="teamName" 
                      placeholder={t?.reg?.teamName || 'Team Name'} 
                      value={formValues.teamName} 
                      onChange={handleInputChange} 
                    />
                  </div>
                )}

                <div className="form-row">
                  <select 
                    name="tshirtSize" 
                    value={formValues.tshirtSize} 
                    onChange={handleInputChange} 
                    required
                  >
                    <option value="S">T-Shirt Size: S</option>
                    <option value="M">M</option>
                    <option value="L">L</option>
                    <option value="XL">XL</option>
                    <option value="XXL">XXL</option>
                  </select>
                  <input 
                    type="text" 
                    name="discountCode" 
                    placeholder={t?.reg?.discountCode || 'Discount Code (optional)'} 
                    value={formValues.discountCode} 
                    onChange={handleInputChange} 
                  />
                </div>

                <div className="form-row checkboxes">
                  <label>
                    <input
                      type="checkbox"
                      name="cookiesConsent"
                      checked={formValues.cookiesConsent}
                      onChange={handleCheckboxChange}
                    />
                    <span>{t?.reg?.cookiesConsent || 'I accept cookies'}</span>
                  </label>
                </div>

                <div className="form-row checkboxes">
                  <label>
                    <input
                      type="checkbox"
                      name="privacyPolicy"
                      checked={formValues.privacyPolicy}
                      onChange={handleCheckboxChange}
                      required
                    />
                    <span style={{ color: !formValues.privacyPolicy && error ? '#c00' : undefined }}>
                      {t?.reg?.privacyPolicy || 'I accept the privacy policy'} *
                    </span>
                  </label>
                  <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
                    {t?.readPrivacyPolicy || 'Read Privacy Policy'}
                  </a>
                </div>

                {error && <div className="form-error">{error}</div>}

                <button type="submit" className="btn primary" disabled={loading}>
                  {loading ? (t?.reg?.submitting || 'Submitting...') : (t?.reg?.submit || 'Register')}
                </button>
              </form>
            </>
          )}
        </div>
      </section>

      <footer className="footer-section">
        <div className="container">
          <p>&copy; 2024 Drim Run. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default PublicHomePageView;
